import { APIResponse } from "../APITypes";
import { csrfHeaders } from '../csrf';

export default class EmailOptOutEndpoint {
    static async Search(searchOptions: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/opt-out/search',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(searchOptions)
                }
            );
        
        if(!response.ok) {
            throw new Error("Email Opt Out search failed.");
        }
        return await response.json();
    }

        static async OptOutByHash(hash: string): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/opt-out/opt-out',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify({hash: hash})
                }
            );
        
        if(!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || "Email opt out failed.");
        }
        return await response.json();
    }
}